<div class="tag-input">
  <div class="tag-input__input-wrapper">
    <input
      pInputText
      class="tag-input__input"
      type="item"
      [formControl]="itemControl"
      [placeholder]="placeholder()"
      (keypress)="handleKeyPress($event)"
    />
    <button
      appButton
      class="tag-input__add-button"
      color="base"
      type="button"
      [disabled]="itemControl.invalid || !itemControl.value?.trim()"
      (click)="addItem()"
    >
      {{ addButtonLabel() }}
    </button>
  </div>

  <div class="tag-input__items">
    @for (item of itemList(); track $index) {
      <span
        class="tag-input__item"
        (click)="deleteItem($index)"
      >
        {{ item }}
        <span class="tag-input__item_delete">
          <svg icon="cancel" />
        </span>
      </span>
    }
  </div>
</div>
